import PropTypes from 'prop-types';
import {ArticleTeaser, Image, ArticleTitle} from './styles';
import TextTruncate from 'react-text-truncate';
import {colors, fonts} from 'ui/config';
import {withRouter} from 'react-router';

const ArticleList = ({header_image, header_titre, id, history}) => {
  const handleClick = () => history.push(`/articles/${id}`);

  return (
    <ArticleTeaser onClick={handleClick}>
      <Image src={header_image} />
      <ArticleTitle>
        <TextTruncate
          style={{
            fontFamily: fonts.title,
            fontWeight: 'bold',
            width: '100%',
            height: 70,
            fontSize: 16,
            lineHeight: '19px',
            color: colors.black,
          }}
          text={header_titre}
          line={2}
        />
      </ArticleTitle>
      {/* <p>{header_titre}</p> */}
      {/* <p>{`link on article - /wp/v2/article/${id}`}</p> */}
    </ArticleTeaser>
  );
};

ArticleList.propTypes = {
  header_image: PropTypes.string,
  header_titre: PropTypes.string,
  id: PropTypes.number,
  history: PropTypes.object.isRequired,
};

export default ArticleList |> withRouter;
